<template>
  <div class="">
    <ZnBreadcrumb>
      <div class="" slot="rightbutton">
        <el-button plain  @click="back" v-if="isBackBtnShow">返回继续添加</el-button>
        <el-button plain  @click="Clear">清空全部试剂</el-button>
        <el-button type="primary"  @click="immediately">立即领用</el-button>
      </div>
    </ZnBreadcrumb>
    <div class="main-content">
      <div class="borrow-details table-container clearfix">
        <div class="table-title">
          <span>领用人信息</span>
        </div>
        <ul>
          <li>
            <label for="借用人">领用人</label>
            <span>{{userName}}</span>
          </li>
<!--          <li>-->
<!--            <label for="开门方式">开门方式</label>-->
<!--            <span>身份码开门</span>-->
<!--          </li>-->
        </ul>

      </div>
      <div class="inventory-library table-container">
        <div class="table-title">
          <span>领用试剂</span>
          <el-button type="primary" v-print="'#printObj'">打印当前清单</el-button>
        </div>
        <div id="printObj" v-if="locationData.length>0">
            <div class="location" v-for="(item,index) in locationData" :key="index">
            <p>所在柜机：<span>{{item.cabName}}</span></p>
            <el-table :data="[item]"
                      :header-cell-style="{background:'#F8FAFC',color:'rgba(0, 0, 0, 0.85)',fontWeight:700,height:'54px'}"
                      border
                      style="width: 100%">
              <el-table-column prop="reagentName"
                              label="药品名称">
              </el-table-column>
              <el-table-column prop="reagentId"
                              label="药品id">
                              <template v-slot="scope">
                                <span v-if="scope.row.reagentCode">{{scope.row.reagentCode}}</span>
                                <span v-else>{{scope.row.reagentId}}</span>
                              </template>
              </el-table-column>
              <el-table-column prop="taskName" label="课题组"></el-table-column>
              <el-table-column prop="casNo" label="CAS号"></el-table-column>


              <el-table-column label="结构式">
                <template slot-scope="scope">
<!--                  <img style="width:50px;height:50px;" class="structionImg" :src="scope.row.structionImg" alt="">-->
                  <el-image style="width:50px;height:50px;" class="structionImg" :src="scope.row.structionImg" alt="" :preview-src-list="[scope.row.structionImg]">

                    <div slot="error" class="image-slot" >
                      <div style="width: 50px;height: 50px;line-height: 50px;text-align: center;background-color:#f5f7fa;color: #c0c4cc" >暂无</div>
                    </div>
                  </el-image>
                </template>             
              </el-table-column>
              <el-table-column prop="reagentRemainWeight"
                              label="库存剂量">
              </el-table-column>
              <el-table-column prop="operation"
                              label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.operation == 1">已入库</span>
                  <span v-if="scope.row.operation == 2">已归还</span>
                  <span v-if="scope.row.operation == 3">已预约</span>
                  <span v-if="scope.row.operation == 4">已取出</span>
                  <span v-if="scope.row.operation == 5">已移除</span>
                  <span v-if="scope.row.operation == 6">已删除</span>
                </template>        
              </el-table-column>
<!--              <el-table-column prop="cabName"-->
<!--                              label="试剂位置">-->
<!--                              <template v-slot="scope">-->
<!--                               <span v-if="$store.state.lock == 'enable'">-->
<!--                                  <span >{{ scope.row.cabName }}</span>-->
<!--                                  <span v-if="scope.row.cabCoords">（{{scope.row.cabCoords}}）</span>-->
<!--                               </span>-->
<!--                                <span v-else>-->
<!--                                  <span >******</span>-->
<!--                               </span>-->
<!--                              </template>-->
<!--              </el-table-column>-->

<!--              <el-table-column label="试剂坐标">-->
<!--                <template slot-scope="scope">-->
<!--                  <span v-if="scope.row.cabCoords">******</span>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column label="领用剂量" width="120px">
                <template slot-scope="scope" >
                  <div class="" style="display: flex;align-items: center;">
                    <el-input v-model="scope.row.borrowNum" size="medium" @change="(val)=>changeBorrowNum(val,scope.row)"
					oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')
					if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
					@blur="reagentWeightBlur"
					
					></el-input>
                    <span style="margin-left:5px;">{{unit(scope.row.reagentWeightUnit) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="领用备注" width="220px;">
                <template slot-scope="scope" >
                  <div class="" style="display: flex;align-items: center;">
                    <el-input v-model="scope.row.remark" type="textarea" size="medium" autosize></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作"
                              >
                <template slot-scope="scope">
                  <el-popover placement="top-start"
                              title="确定删除吗？"
                              width="200"
                              trigger="click">
                    <!-- <el-button size="mini">取消</el-button> -->
                    <el-button type="primary"
                              size="mini" @click="deleteGoods(scope.row)">确定</el-button>
					</el-popover>

				  <img   @click="deleteGoods(scope.row)"  
				 src="../../assets/private/del.png"
				  title="删除" style="height: 25px;width: 25px;float: left;">
					   
                              
            <!--    <img @click="borrowGoods(scope.row)" src="../../assets/private/del.png" title="删除" 
				style="height: 25px;width: 25px;float: left;">
              -->
                  

                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <template v-else>
          <div class="no-date">
            <div>
              <img src="../../assets/images/empty.png"
                  alt="">
              <p>暂无领用药品</p>

            </div>
          </div>
        </template>
      </div>
      <div>
        <el-collapse accordion style="border: 0;margin-top: 20px;margin-left: 20px" class="custom-collapse1">
          <el-collapse-item class="custom-collapse-item1">
            <template slot="title">
              <span >点击查看领用归还流程<i class="header-icon el-icon-question"></i></span>
            </template>
            <img src="../../assets/images/borrow.png" alt="领用归还流程">
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

  </div>
</template>
<script>
import {EventBus} from "@/config/event-bus";

export default {
  data() {
    return {
      isBackBtnShow:true,
      lastRoute:null,
      num: 1,
      dialogAddCart: false,
      dialogBorrow: false,
      formLabelWidth: '120px',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      content: '',
      locationData: [],
      howWidth: 12,
      userName:''
    }
  },
  created() {
    this.initData()
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.userName = userInfo.accountName
    this.routeQuery();
  },

  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     // 通过 `vm` 访问组件实例,将值传入fromPath
  //     vm.lastRoute = from.path;
  //     console.log(from)
  //     if(from.params.type == "/ReagentRun" || from.path == "/searchPage"){
  //       vm.isBackBtnShow = true;
  //     }else {
  //       vm.isBackBtnShow = false;
  //     }
      
  //   });
  // },
  methods: {
    // 路由参数
    routeQuery(){
      if(this.$route.query){
        if(this.$route.query.type == "reagentRun" || this.$route.query.type == "searchPage"){
          console.log(this.$route.query.type)
        this.isBackBtnShow = true;
        }else{
          console.log(this.$route.query.type)
          this.isBackBtnShow = false;
        }
      }
    },
    getYuYueNum(){
      this.$apiFetch
          .get("/lockerBorrowRecord/selectMarkRecordCount")
          .then((res) => {
            localStorage.setItem("yuYueNum",res.data);
            EventBus.$emit('yuYueNum',res.data);
          });
    },
    // 单位
    unit(reagentWeightUnit){ //单位适配
      return reagentWeightUnit == 1 ? "mL" : reagentWeightUnit == 2?"g": 
                reagentWeightUnit == 3?"mg": reagentWeightUnit == 4?"L":reagentWeightUnit == 5?"kg":reagentWeightUnit == 6?"KU":reagentWeightUnit == 7?"U":""
    },
    handleChange(value) {
      console.log(value)
    },
	reagentWeightBlur(){
	  let value = this.form.reagentWeight
	  if(value.slice(value.length-1,value.length)=='.'){this.form.reagentWeight = value.slice(0,value.length-1)}
	   },
    //查看预约
    toSeeLibrary() {
      this.$router.push({ path: 'borrowInfo' })
    },
    //在线库存借用
    borrowGoods() {
      this.dialogBorrow = true
    },
    // 删除借用
    deleteGoods(data){
	this.$confirm("确定删除预约?", "提示", {
	  confirmButtonText: "确定",
	  cancelButtonText: "取消",
	  type: "warning",
	})
	  .then(() => {	
      this.$apiFetch.post('/lockerBorrowRecord/deleteMarkBorrow',{reagentId:data.reagentId}).then(() => {
        this.$message({
          showClose: true,
          message: "删除成功",
          type: "success",
        });
        this.initData()
        this.getYuYueNum();
      })
      .catch((error) => {
        console.log(error)
      })
      this.dialogBorrow = false
	    });
    },
    //确认借用在线库存
    confirmBorrow() {
      this.dialogBorrow = false
      this.$notify({
        title: '领用成功',
        message: '请使用PDA扫描身份码领取',
        position: 'bottom-right',
      })
    },
    toMyPurchase() {
      this.$router.push({ path: 'myPurchase' })
    },
    //加入购物车
    addCart() {
      this.dialogAddCart = true
    },
    //
    handleClick(row) {
      console.log(row)
    },
    initData() {
      this.$apiFetch
        .get('/lockerBorrowRecord/selectMarkRecord')
        .then((data) => {
          if(!data.data.code){
            
            // this.locationData.forEach(item=>{
            //   if(!item.borrowNum){
            //     this.$set(item,'borrowNum',1)
            //   }
            // })
            this.locationData = []
			 data.data.map((item) => {
				 item.reagentWeight=parseFloat(item.reagentWeight);
				 item.reagentRemainWeight=parseFloat(item.reagentRemainWeight)+this.unit(item.reagentWeightUnit);
				 //item.currentCommand = reagentWeightUnit == 1 ? "ml" : "g";
				  });
          
				  this.locationData = data.data
          }else{
            this.$message.error(data.data.description)
          }
        })  
        .catch((error) => {
          console.log(error)
        })
    },

    back(){
      this.$router.back()
      // if(this.lastRoute == "/ReagentRun" || this.lastRoute == "/searchPage"){
      //   this.$router.back()
      // }else {
      //   this.$message.warning("不是从预约界面来的，不能返回...")
      // }
    },
    Clear(){
      // let arr = this.
      const records = this.locationData.map(item=>{return {reagentId:item.reagentId}})
      this.$apiFetch.post('/lockerBorrowRecord/removeMarkBorrow',records)
        .then((res) => {
          if(!res.data.code){
            this.$message.success('清除成功')
            this.initData()

            localStorage.setItem("yuYueNum",0);
            EventBus.$emit('yuYueNum',0);
          }else{
            this.$message.error(res.data.description)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    immediately(){
      if(this.locationData.length == 0){
        this.$message({
          showClose: true,
          message: "请选择要领用的药品",
          type: "error",
        });
        return
      }
      let flag = false;
      const params = this.locationData.map(item=>{
        if(!item.borrowNum){
          this.$message.error('请输入正确剂量后提交')
          flag = true;
          return;
        }
        return {reagentId:item.reagentId,borrowNum:item.borrowNum,remark:item.remark}
        })
        if(flag) return;
      this.$apiFetch.post('/lockerBorrowRecord/addMarkBorrow',params)
        .then((res) => {
          if(!res.data.code){
            this.initData()
            this.$notify({
              title: '领用成功',
              message: '请使用PDA扫描身份码领取',
              position: 'bottom-right',
            })
            this.getYuYueNum();
            this.initData();
            this.$router.push("/ReagentRun")
          }else{
             this.$message.error(res.data.description)
          }
        })
        .catch((error) => {
          console.log(error)
        })

    },
    changeBorrowNum(val,data){
      // 修改计量
      console.log(val,data)
      if(val > parseFloat(data.reagentRemainWeight)){
        this.$message.error('领用剂量不能超过库存剂量')
        this.initData()
        return
      }
      if(val <= 0 ||!val){
        this.$message.error('请输入正确的剂量')
        this.initData()
        return
      }
      this.$apiFetch.post('/lockerBorrowRecord/updateMarkBorrow',{
        reagentId:data.reagentId,
        borrowNum:val
      }).then((res) => {
        if(!res.data.code){
           this.$message.success('修改成功')
           this.initData()
        }else{
           this.$message.error(res.data.description)
        }
      })
      .catch((error) => {
        console.log(error)
      })
    }
  },
}
</script>
<style lang="less" scoped>
.no-date {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    display: block;
    width: 148px;
  }
  p {
    color: #b1c4e2;
    font-size: 14px;
    line-height: 20px;
    margin-top: 14px;
    text-align: center;
  }
}

.table-container {
  padding: 20px;
  margin-top: 20px;
  background-color: #ffffff;
  .table-title {
    color: #333333;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    position: relative;
    padding-left: 11px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eef2f8;
    button {
      position: absolute;
      bottom: 9px;
      right: 0;
      height: 36px;

      border-radius: 4px;
      font-size: 12px;
      color: #ffffff;
    }
  }
  .table-title::before {
    width: 3px;
    height: 16px;
    background: #478aff;
    content: '';
    position: absolute;
    left: -6px;
    top: 3px;
  }
  .location {
    p {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      padding: 20px 0 8px 0;
      span {
        color: rgba(0, 0, 0, 0.85);
        font-weight: 700;
      }
    }
    /deep/ .el-button--text {
      color: #ff4d4f;
    }
  }
}
.borrow-details {
  margin-top: 0;
  ul {
    margin-top: 20px;
    background-color: #f8fafc;
    padding: 0 20px;
    li {
      box-sizing: border-box;
      width: 100%;
      border-bottom: 1px solid #eef2f8;
      height: 51px;
      line-height: 51px;
      display: flex;

      label {
        color: #666666;
        font-size: 14px;
        width: 120px;
      }
      span {
        color: #333333;
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.el-button--primary {
  background: #478aff;
  border-color: #478aff;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #e7f3fe !important;
}
.el-notification.right {
  border-left: 5px solid #00ca00;
  width: 478px;
  height: 136px;
  box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
  border-radius: 12px;
  background: url('../../assets/images/successBor.png') no-repeat 39px center;
  background-color: #ffffff;
  box-sizing: border-box;
  background-size: 64px;
  .el-notification__title {
    padding: 26px 0px 0 109px;
    color: #333333;
    font-size: 18px;
  }
  .el-notification__content p {
    padding-left: 109px;
    color: #999999;
    font-size: 16px;
  }
}

.el-popover {
  text-align: center;
  color: #333333;
  font-size: 18px;
  font-weight: 700;
  padding: 20px 0;
}
.el-popover__title {
  font-size: 14px;
  font-weight: normal;
}
.structionImg{
  width: auto;
  height: 80px;
}

.el-input{
  flex:1;
}
</style>
